$(document).ready(function() {
  $('.footer__up').on('click', function() {
    $("html, body").animate({scrollTop: 0}, 1000);
  });

  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", vh + "px");

  window.addEventListener("resize", function () {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");
  });

  $(window).on('scroll',function () {
    if($(this).scrollTop() > 50) {
        $('.page-header').addClass('page-header--scrolled');
    } else {
        $('.page-header').removeClass('page-header--scrolled');
    }
  });

  $('#hamburger').on('click', function() {
    $(this).toggleClass('active');
    $('.site-navigation').toggleClass('active');
  });

  $("[href^='#']").click(function() {
    var id = $(this).attr("href");
    $('html, body').animate({
        scrollTop: $(id).offset().top - 200
    }, 1000);
  });

  $('select').niceSelect();

  $('.slider').slick({
    fade: true,
    dots: true,
    arrows: false,
    draggable: false,
    pauseOnHover: false,
    autoplay: true,
    appendDots: $('.slider__dots'),
    customPaging: function(slider, i) {
      var name = $(slider.$slides[i]).find('.slider__wrapper').data('title');
      var number = ( '0' + (i+1) ).slice(-2);
      return '<button class="tab">' + number + '<br/>' + name + '</button>';
    }
  });

  $('.slider').on('afterChange', function(event, slick, currentSlide) {
    $('.slider__count').text(( '0' + (currentSlide+1) ).slice(-2));
  });

  if ( ($('.slider__content').length > 0) && (window.matchMedia('(min-width: 992px)').matches) ) {
    $('.slider__content').css('height', $('.slider__wrapper').outerHeight() + 'px');
  }

  $(document).on('wpcf7invalid', function() {
    $('select').niceSelect('update');
  });

  $('.slider').on('touchstart', e => {
    $('.slider').slick('slickPlay');
  });

  if ( $('.group-block').length > 0 ) {
    let heights = $('.group-block').map(function() {
      return $(this).outerHeight();
    });
    let max_height = Math.max.apply(null, heights);
    console.log(max_height);
    $('.group-block').css('minHeight', max_height + 'px');
  }

  if ( $('.groups .groups__item').length > 0 ) {
    let heights = $('.groups .groups__item').map(function() {
      return $(this).outerHeight();
    });
    let max_height = Math.max.apply(null, heights);
    console.log(max_height);
    $('.groups .groups__item').css('minHeight', max_height + 'px');
  }

});